
import { LangText } from '../zustand/dict';
import routes from './routes';

const exportData = {
  // s3url: 'https://esr-tests3.s3.ap-northeast-2.amazonaws.com/',
  // imgUrl: 'http://ew.pnsoft.co.kr:40090',
  imgUrl: 'https://lab-api.aiwith.art',
  pagerows: 100,
  headerMode: {
    NORMAL: "normal",
    BACK: "back",
    BACKONLY: "backonly",
  },
  toastOption: {
    isLoading: false,
    autoClose: 2000,
    closeOnClick: true,
    pauseOnHover: false
  },
  toastErrorOption: {
    isLoading: false,
    autoClose: 2000,
    closeOnClick: true,
    pauseOnHover: false,
    position: 'bottom-center'
  },
  imgAlt: 'CARMASTER',
  termTypeConsts: [
    { idx: 1, title: "title_policy_service" },
    { idx: 2, title: "title_policy_privacy" },
    { idx: 3, title: "title_policy_marketing" },
    { idx: 4, title: "회원 탈퇴 약관" }
  ],
  mobileWidth: 1024,
  animationFadeIn: "animate__animated animate__faster animate__fadeIn",
  loaderVariants: {
    open: { opacity: 1, display: 'flex' },
    closed: { opacity: 0, display: 'none' },
  },
  loaderBlurVariants: {
    open: { backdropFilter: 'blur(3px)', display: 'flex' },
    closed: { backdropFilter: 'blur(0px)', display: 'none' },
  },

  loginBoxVariants: {
    open: { opacity: 1, scale: 1, display: 'flex' },
    closed: { opacity: 0, scale: 1.05, display: 'none' },
  },

  headerVariants: {
    open: { opacity: 1, y: 0, display: 'block' },
    closed: { opacity: 0, y: -10, display: 'none' },
  },
  defaultModalValue: {
    open: false,
    title: <LangText id={"text_popup_alarm"} />,
    message: "",
    type: "",
    isClose: false
  }
}

export default exportData;